// extracted by mini-css-extract-plugin
module.exports = {"projectPopup":"ProjectPopup_projectPopup__yjE00","popupContainer":"ProjectPopup_popupContainer__JqmVk"};